module.exports = __webpack_public_path__ + "img/template_6.ae111e5c.png";